import type { DashboardMode } from "@/features/dashboard/types/dashboard.types";

type DrilldownDataQueryHydrationPhase = "pending" | "hydrated";

/**
 * Drilldown URL hydration does not reset on tenant switch. Store tenant
 * updates only inside resetForTenant, in the same set() as the product write.
 */
export function isDrilldownDataQueryEnabled(args: {
  pageMode: DashboardMode;
  queryMode: DashboardMode;
  urlHydrationPhase: DrilldownDataQueryHydrationPhase;
  storeTenantId: string | null;
  activeTenantId: string | null;
}): boolean {
  return (
    args.pageMode === args.queryMode &&
    args.urlHydrationPhase === "hydrated" &&
    args.storeTenantId !== null &&
    args.storeTenantId === args.activeTenantId
  );
}
